// extracted by mini-css-extract-plugin
export default {"Box":"StickyLinesHeader-module__Box--tCWj4","Box_1":"StickyLinesHeader-module__Box_1--vlFhw"};